'use strict';

// // AngularJS
//const angular = require('angular');
import "angular";
//import "angular-sanitize";
//
////import "angular-route";
//import "angular-messages";
//
////import "angular-cookies";
//import "angular-animate";
//import "angular-aria";
//
import "angular-ui-bootstrap";

var EwSiteApp = angular.module('EwSiteApp', ['ui.bootstrap']);

EwSiteApp.config(['$provide', function ($provide) {
		$provide.decorator('$browser', ['$delegate', function ($delegate) {
				$delegate.onUrlChange = function () {};
				$delegate.url = function () {
					return "";
				};
				return $delegate;
			}]);
	}]);

EwSiteApp.filter('u2date', ['$filter', function ($filter) {
		return function (udate) {
			var format = 'yyyy-MM-dd';
			if (arguments[1]) {
				format = arguments[1];
			}
			return $filter('date')(udate * 1000, format);
		};
	}]);

EwSiteApp.service("ajaxSearch", ['$http', '$q', function ($http, $q) {
		return({
			search: search
		});

		function search(url) {
			var cfg = {
				method: 'GET',
				url: url
			};
			if (arguments[1]) {
				cfg.params = arguments[1];
			}
			var request = $http(cfg);
			return(request.then(succesHandler, errorHandler));
		}
		;

		function succesHandler(response) {
			return response.data;
		}

		function errorHandler(response) {
			if (!angular.isObject(response.data) || !response.data.message) {
				return($q.reject("An unknown error occurred."));
			}
			return($q.reject(response.data.message));
		}
		;
	}]);

EwSiteApp.directive('select2', ['$timeout', function ($timeout) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				// Initialize Select2 on the element
				$timeout(function () {
					$(element).select2({
						minimumResultsForSearch: Infinity
					});

					// Handle dynamic placeholder if the element has the class
					if ($(element).hasClass('select2_with_dynamic_placeholder')) {
						$(element).select2({
							minimumResultsForSearch: Infinity,
							placeholder: $(element).data('placeholder')
						});
					}

					// Watch for changes in the select element
					scope.$watch(function () {
						return element[0].innerHTML;
					}, function (newVal, oldVal) {
						if (newVal !== oldVal) {
							$timeout(function () {
								$(element).trigger('change'); // Reinitialize Select2 if content changes
							});
						}
					});
				});
			}
		};
	}]);

EwSiteApp.directive('select2WithSearch', ['$timeout', function ($timeout) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				// Initialize Select2 on the element
				$timeout(function () {
					$(element).select2({
						// Allow search by omitting 'minimumResultsForSearch' or setting a threshold value
						placeholder: $(element).data('placeholder') || undefined // Dynamic placeholder support
					});

					// Handle dynamic placeholder if the element has the class
					if ($(element).hasClass('select2_with_dynamic_placeholder')) {
						$(element).select2({
							placeholder: $(element).data('placeholder')
						});
					}

					// Watch for changes in the select element
					scope.$watch(function () {
						return element[0].innerHTML;
					}, function (newVal, oldVal) {
						if (newVal !== oldVal) {
							$timeout(function () {
								$(element).trigger('change'); // Reinitialize Select2 if content changes
							});
						}
					});
				});
			}
		};
	}]);


export {EwSiteApp};